import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  EmployeeToEngagementCompanyAccessLinkContainerModel,
} from '../../../../../../models/aggregates/erp/engagement';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeToEngagementCompanyAccessLinkService extends BaseApiTemplateService<EmployeeToEngagementCompanyAccessLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.ENGAGEMENT_PREFIX + 'employee-to-engagement-company-access-links/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.ENGAGEMENT_PREFIX + 'employee-to-engagement-company-access-links/backoffice-ep';
    this.httpClient = http;
  }

  public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
